export type SwotFormErrorSummaryProps = {
  readonly title?: string | undefined;
  readonly message?: string | undefined;
  readonly fieldErrors?: Record<string, readonly string[]> | undefined;
  readonly dependencyCount?: number | undefined;
  readonly correlationId?: string | undefined;
  readonly remediation?: string | undefined;
};

function countFieldMessages(fieldErrors?: Record<string, readonly string[]>): number {
  if (!fieldErrors) return 0;
  return Object.values(fieldErrors).reduce((total, messages) => total + messages.length, 0);
}

export function SwotFormErrorSummary(props: SwotFormErrorSummaryProps) {
  const fieldMessageCount = countFieldMessages(props.fieldErrors);
  const hasContent = Boolean(props.message || props.remediation || props.correlationId || fieldMessageCount > 0 || props.dependencyCount);
  if (!hasContent) return null;
  return (
    <section className="swot-form-error-summary" role="alert" aria-live="polite">
      <h3>{props.title ?? "Review the form"}</h3>
      {props.message ? <p>{props.message}</p> : null}
      {fieldMessageCount > 0 ? <p>{fieldMessageCount} field validation message{fieldMessageCount === 1 ? "" : "s"} need attention.</p> : null}
      {props.dependencyCount ? <p>{props.dependencyCount} blocking dependenc{props.dependencyCount === 1 ? "y" : "ies"} must be resolved.</p> : null}
      {props.remediation ? <p><strong>Recommended action:</strong> {props.remediation}</p> : null}
      {props.correlationId ? <p><strong>Support reference:</strong> {props.correlationId}</p> : null}
    </section>
  );
}
